module.exports = __webpack_public_path__ + "static/media/2.d360a6b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/2.jpg
// module id = 86
// module chunks = 0